import React from 'react';

export interface Theme {
  color: {
    primary: string;
    secondary: string;
    button: string;
    metaText: string;
    blurOverlay: string;
    border: string;
    darkPrimary: string;
  };
  fontFamily: {
    main: string;
  };
  fontWeight: {
    main: string;
    header: string;
  };
  fontSizes: {
    small: string;
    base: string;
    h1: string;
    h2: string;
    h3: string;
    h4: string;
    h5: string;
    button: string;
  };
  fontLineHeight: {
    standard: string;
    large: string;
  };
  spacing: {
    standard: string;
    large: string;
    extraLarge: string;
  };
}

export const theme: Theme = {
  color: {
    primary: '#ffffff',
    secondary: '#000000',
    button: '#cdd9c4',
    metaText: 'rgba(0, 0, 0, 0.7)',
    blurOverlay: 'rgba(27, 27, 27, 0.25)',
    border: '#dedede',
    darkPrimary: '#f9f9f9',
  },
  fontFamily: {
    main: 'Global',
  },
  fontWeight: {
    main: '500',
    header: '700',
  },
  fontSizes: {
    small: '14px',
    base: '18px',
    h1: '3.25rem',
    h2: '2.25rem',
    h3: '1.875rem',
    h4: '1.25rem',
    h5: '1.5rem',
    button: '1.5rem',
  },
  fontLineHeight: {
    standard: '1.71em',
    large: '6.3rem',
  },
  spacing: {
    standard: '1rem',
    large: '2rem',
    extraLarge: '4rem',
  },
};
export const themes = { theme };

export const ThemeContext = React.createContext(themes.theme);
